import { useState } from "react";
import useGroupBranchOptions from "./useGroupBranchOptions";

/**
 * The "post to" picker shared by every Group Console create form — same
 * choice already shipped for School Posts (components/sections/Announcement.js):
 * "All Branches" or one specific branch, never an arbitrary multi-pick.
 *
 * Resolves "All Branches" to every branch id itself before the caller ever
 * sends a request, so the backend contract stays a plain non-empty array of
 * ids regardless of which choice was made.
 */
export default function useTargetSchools() {
  const branches = useGroupBranchOptions();
  const [target, setTarget] = useState("all");

  const targetSchools =
    target === "all" ? branches.options.map((o) => o.value) : [target];

  const selectProps = {
    value: target,
    onChange: setTarget,
    loading: branches.isLoading,
    options: [
      { value: "all", label: "All Branches" },
      ...branches.options,
    ],
  };

  return { targetSchools, selectProps, branches: branches.options };
}
